module.exports = __webpack_public_path__ + "static/1-04ccfcd030a77e91b3c63018037e9bce.png";